module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAATElEQVQ4y83UwQ0AIAgDwCYO0JFc3ZEcwKRCjMYNKB96XwhAX00Ua+BWrxelCE0OQgbJQjzLgoOih96UahUBlIW48rQWHGR00z6/bgPEO+sT4AatDgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNzowOCswOTowMBCC6ssAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjIrMDk6MDA/qCjNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00358_100x100.png
// module id = dZzw
// module chunks = 0